import { useEffect, useState } from 'react';
import { useNFTS } from '../../hooks/useNFTS';
import { ethers } from 'ethers';
import config from './../../config';
import { CircularProgress } from '@mui/material';
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { setToast } from '../../store/actions/Toast';

declare var window: any;
const YieldCard = (props: any) => {
  const [earned, setEarned] = useState("0");
  const [stakedIds, setStakedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const myNFTs = useNFTS();
  const dispatch: Dispatch<any> = useDispatch();

  const init = async () => {
    if (myNFTs.nfts.staked) {
      // const earned = ethers.utils.formatEther(myNFTs.nfts.earned)
      // setEarned(earned);
      const staked = myNFTs.nfts.staked.map((s: any) => s.beeId).filter((id: any) => id !== 0)
      setStakedIds(staked)
      updateReward(staked);
    }
  }
  const addToMetamask = async () => {
    let provider = new ethers.providers.Web3Provider(window.ethereum as any);

    const signer = provider.getSigner();
    const mToken = new ethers.Contract(
      config.TokenAddress,
      config.MTokenAbi,
      provider
    );
    const tokenSymbol = await mToken.symbol();
    const tokenAddress = config.TokenAddress;

    try {

      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: 18,
            image: "https://monstermycity-images.s3.amazonaws.com/monstermycityWB.png",
          },
        },
      });

      if (wasAdded) {
        dispatch(
          setToast({
            visible: true,
            message: `$MONSTER added`,
            type: "success",
          })
        );
      } else {
        setToast({
          visible: true,
          message: `Something went wrong`,
          type: "error",
        })
      }
    } catch (error) {
      console.log(error);
    }
  }


  const claim = async () => {
    let provider = new ethers.providers.Web3Provider(window.ethereum as any);

    const signer = provider.getSigner();

    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer// signer !== null ? signer : provider
    );
    try {
      const stakedIds = myNFTs.nfts.staked.map((s: any) => s.beeId).filter((id: any) => id !== 0);
      setLoading(true)
      const claim = await yieldContract.claim(stakedIds);
      dispatch(
        setToast({
          visible: true,
          message: `Received ${earned} $MONSTER`,
          type: "success",
        })
      );
      listenClaimed();
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }

  }

  const listenClaimed = () => {
    let provider = new ethers.providers.Web3Provider(window.ethereum as any);

    const signer = provider.getSigner();
    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );
    try {
      console.log("Listener started");
      // const provider = new ethers.providers.JsonRpcProvider(
      //   "https://rinkeby.infura.io/v3/799ad57d4067419db57bf9592b471301"
      // );

      const filter = yieldContract.filters.Claimed();

      console.log("watching for events...");
      // Receive an event when that filter occurs
      yieldContract.on(filter, async (from, to, amount, event, unknow) => {
        updateReward(stakedIds);
      });
    } catch (err) {
      console.log(err);
    }
  }

  const updateReward = async (stakedIds: any) => {
    let provider = new ethers.providers.Web3Provider(window.ethereum as any);

    const signer = provider.getSigner();
    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );
    try {
      const earned = await yieldContract.earned(stakedIds);
      const earnedFormat = ethers.utils.formatEther(earned._hex.toString())
      setEarned(earnedFormat);
    } catch (err) {
      console.log(err);
    }
    setTimeout(() => {
      updateReward(stakedIds);
    }, 60000);
  }

  useEffect(() => {
    init()
  }, [myNFTs]);

  return (
    <div className="yield-card">
      <div className="card-header">
        <h1>My {props.nameToken} Yield</h1>
      </div>
      <button onClick={addToMetamask} >
        <span>
          Add to
        </span>
        <img src={require("../../assets/metamask.png").default} alt="" />
      </button>
      <div className='yield-body'>
        <p>{earned.toString().substring(0, 7)}</p>
        {loading ? <CircularProgress />
          : <button onClick={claim} disabled={!(parseFloat(earned) > 0)}>
            Claim
          </button>}
      </div>

    </div>
  );
};

export default YieldCard;
